import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "full-height q-px-sm overflow-auto" }
const _hoisted_3 = { class: "q-ma-none" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "q-my-sm" }
const _hoisted_6 = { class: "q-my-sm" }

import { Notify, useDialogPluginComponent } from "quasar"
import { DeepReadonlyObject } from "rxdb"
import { Subscription } from "rxjs"
import SfxCardModel from "src/components/card/SfxCardModel.vue"
import SfxEmptyPage from "src/components/empty/SfxEmptyPage.vue"
import SfxTopNavigation from "src/components/navigation/SfxTopNavigation.vue"
import SfxSearchBar from "src/components/search/SfxSearchBar.vue"
import SfxSpinner from "src/components/special/SfxSpinner.vue"
import { getDB } from "src/db/databases"
import { useSearchStore } from "src/stores/searchStore"
import { useSupportStore } from "src/stores/supportStore"
import { useTopNavigationStore } from "src/stores/topNavigationStore"
import { EmptyStates } from "src/util/constants/emptyStates"
import { ContextAction, MissingEntityType } from "src/util/enums/entityType"
import { NavigationAction } from "src/util/enums/topNavigation"
import { selectModel } from "src/util/functions/dialogs"
import { getItemClassListData } from "src/util/functions/entityData"
import { SearchMap } from "src/util/search/searchMap"
import { ItemClass } from "src/util/types/dataModels/itemClass"
import { ItemModel } from "src/util/types/dataModels/itemModel"
import { computed, onMounted, onUnmounted, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'ModelClassOverlay',
  props: {
  itemDesignation: {
    type: String,
    required: true,
  },

  currentItemClass: {
    type: Object as PropType<ItemClass>,
  },

  currentItemModel: {
    type: Object as PropType<ItemModel>,
  },

  canGoToOverview: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const searchStore = useSearchStore()
const supportStore = useSupportStore()
const topNavigationStore = useTopNavigationStore()
const topNavigationContainer = ref<HTMLDivElement | null>(null)
const { dialogRef, onDialogCancel, onDialogOK, onDialogHide } = useDialogPluginComponent()
let subscription: Subscription

const currentItemModel = ref<ItemModel | undefined>(props.currentItemModel)
let itemModelList = ref<DeepReadonlyObject<ItemModel[]> | undefined>(undefined)
let itemClassList = ref<DeepReadonlyObject<ItemClass[]> | undefined>(undefined)
const spinnerText = t("sfxSpinner.model_data")

const searchMap = computed(() => {
  return new SearchMap<DeepReadonlyObject<ItemModel>, DeepReadonlyObject<ItemModel>>(
    (item) => [{ term: item.designation, value: item }],
    {},
    itemModelList.value || undefined
  )
})

const filteredItemModels = computed(() => {
  let result: DeepReadonlyObject<ItemModel[]>
  result = searchStore.term
    ? searchMap.value.getPartialMatches(searchStore.term)
    : [...(itemModelList.value ?? [])].filter(
        (itemModel) => itemModel.id !== currentItemModel.value?.id
      )

  return result
})

const contentContainer = computed(() => {
  const topNavigationHeight = topNavigationContainer.value?.offsetHeight || 0
  return { height: `calc(100% - ${topNavigationHeight}px)` }
})

const searchBarDisabled = computed(
  () => !searchStore.enabled || (itemModelList.value && itemModelList.value.length === 0)
)

//endregion

//region Lifecycle

onMounted(async () => {
  itemModelList.value = await getItemModelsData()

  if (!props.currentItemClass) {
    const itemClassDocuments = await getItemClassListData()
    itemClassList.value = itemClassDocuments.map((element) => element.toJSON())
  }

  searchStore.enabled = true
  searchStore.domain = "models"
  supportStore.setFeedbackData(t("model.title"))

  subscription = topNavigationStore.contextActionClicked.subscribe()
})

onUnmounted(() => {
  subscription?.unsubscribe()
})

//endregion

//region Functions

async function getItemModelsData() {
  const db = await getDB()
  const results = await db.item_model
    .find()
    .where("item_class")
    .eq(props.currentItemClass?.id)
    .exec()

  const itemModels = results.map((doc) => doc.toJSON())
  return itemModels.sort((a, b) => a.designation.localeCompare(b.designation))
}

function getItemClassDesignation(itemClassId: string) {
  return props.currentItemClass
    ? props.currentItemClass.designation
    : itemClassList.value?.find((itemClass) => itemClass.id === itemClassId)?.designation
}

function modelClick(itemModel: ItemModel) {
  selectModel(props.itemDesignation, itemModel.designation, props.canGoToOverview).onOk(() =>
    onDialogOK(itemModel)
  )
}

function modelLongClick(itemModel: ItemModel) {
  if (!props.canGoToOverview) return

  Notify.create({
    message: "Go to overview page of: " + itemModel.id,
    color: "positive",
  })

  onDialogHide()
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_touch_hold = _resolveDirective("touch-hold")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    "transition-show": "slide-up",
    "transition-hide": "slide-down",
    class: "full-height",
    maximized: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "window-height" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "topNavigationContainer",
            ref: topNavigationContainer
          }, [
            _createVNode(SfxTopNavigation, {
              title: props.itemDesignation,
              "navigation-action": _unref(NavigationAction).CLOSE,
              menuContent: [_unref(ContextAction).CREATE_MODEL],
              "quick-action": _unref(ContextAction).CREATE_MODEL,
              "disable-notifications": "",
              onClose: _unref(onDialogCancel),
              class: "shadow"
            }, {
              subtitle: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: _ctx.$t('modelClassOverlay.subtitle')
                }, null, 8, _hoisted_1)
              ]),
              _: 1
            }, 8, ["title", "navigation-action", "menuContent", "quick-action", "onClose"]),
            _createVNode(SfxSearchBar, {
              class: "q-toolbar q-pb-md q-px-md",
              disable: searchBarDisabled.value
            }, null, 8, ["disable"])
          ], 512),
          _createVNode(_component_q_scroll_area, {
            class: "q-px-md q-pb-sm scrollbar-area",
            style: _normalizeStyle(contentContainer.value)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_unref(itemModelList) === undefined)
                  ? (_openBlock(), _createBlock(SfxSpinner, {
                      key: 0,
                      text: _unref(spinnerText)
                    }, null, 8, ["text"]))
                  : (_unref(itemModelList)?.length === 0)
                    ? (_openBlock(), _createBlock(SfxEmptyPage, {
                        key: 1,
                        class: "full-width q-px-lg",
                        missingEntity: _unref(EmptyStates).get(_unref(MissingEntityType).MODEL_NOT_FOUND),
                        "vertical-center": ""
                      }, null, 8, ["missingEntity"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (filteredItemModels.value.length === 0)
                          ? (_openBlock(), _createBlock(SfxEmptyPage, {
                              key: 0,
                              class: "full-width q-px-lg",
                              missingEntity: _unref(EmptyStates).get(_unref(MissingEntityType).MODEL_NO_MATCHES),
                              "vertical-center": ""
                            }, null, 8, ["missingEntity"]))
                          : _createCommentVNode("", true),
                        (filteredItemModels.value.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!_unref(searchStore).term && props.currentItemModel)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("h6", _hoisted_3, [
                                      _createElementVNode("span", {
                                        innerHTML: _ctx.$t('modelClassOverlay.restricted')
                                      }, null, 8, _hoisted_4),
                                      _createTextVNode(" " + _toDisplayString(props.currentItemClass.designation), 1)
                                    ]),
                                    _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.$t("modelClassOverlay.model_current")), 1),
                                    _withDirectives(_createVNode(SfxCardModel, {
                                      "item-model": props.currentItemModel,
                                      "item-class-designation": props.currentItemClass?.designation,
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (modelClick(props.currentItemModel)))
                                    }, null, 8, ["item-model", "item-class-designation"]), [
                                      [
                                        _directive_touch_hold,
                                        () => modelLongClick(props.currentItemModel),
                                        void 0,
                                        { mouse: true }
                                      ]
                                    ]),
                                    _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.$t("modelClassOverlay.model_other")), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItemModels.value, (itemModel) => {
                                return _withDirectives((_openBlock(), _createBlock(SfxCardModel, {
                                  key: itemModel.id,
                                  "item-model": itemModel,
                                  "item-class-designation": getItemClassDesignation(itemModel.item_class),
                                  onClick: ($event: any) => (modelClick(itemModel))
                                }, null, 8, ["item-model", "item-class-designation", "onClick"])), [
                                  [
                                    _directive_touch_hold,
                                    () => modelLongClick(itemModel),
                                    void 0,
                                    { mouse: true }
                                  ]
                                ])
                              }), 128))
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})